import ParamMaker from '@/utils/modules/ParamMaker'
import axios from '@/services/axiosConfig'

const endPoint = {
	lookupInstInfo: instId => `/institute/${instId}`,
	lookupLicense: instId => `/institute/${instId}/license`,
	editInstInfo: instId => `/institute/${instId}`,
	lookupMemberAll: (instId, keyword, groupsIdList, offset, length) =>
		`institute/${instId}/member/list?keyword=${keyword}&${ParamMaker.setArrayString(
			'groupsId',
			groupsIdList
		)}&offset=${offset}&length=${length}`,
	lookupSummary: instId => `/institute/${instId}/sidebar/summary`,
}

const instituteInformationAPI = {
	lookupInstInfo: instId => axios.get(endPoint.lookupInstInfo(instId)),
	lookupLicense: instId => axios.get(endPoint.lookupLicense(instId)),
	editInstInfo: (instId, formData) =>
		axios.put(endPoint.editInstInfo(instId), formData, {
			headers: {
				'Content-Type': 'multipart/form-data',
			},
		}),
	lookupMemberAll: (instId, keyword, groupsIdList, offset, length) =>
		axios.get(
			endPoint.lookupMemberAll(
				instId,
				keyword,
				groupsIdList,
				offset,
				length
			)
		),
	lookupMemberInfo: (instId, id) =>
		axios.get(endPoint.lookupMemberInfo(instId, id)),
	lookupAuthorityList: instId =>
		axios.get(endPoint.lookupAuthorityList(instId)),
	lookupSummary: instId => axios.get(endPoint.lookupSummary(instId)),
}

export default instituteInformationAPI
